// MF-67 — List toolbar shared by the journal lists: a compact debounced search (icon + inline clear)
// on the left, and an optional right-hand slot (`children`) for counts, hints or extra actions.
import { useEffect, useState } from 'react'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ListSearch = ({ value = '', onChange, placeholder = 'Search…', children }) => {
  const [input, setInput] = useState(value)

  useEffect(() => {
    const t = setTimeout(() => {
      if (input !== value) onChange(input)
    }, 350)
    return () => clearTimeout(t)
    // Debounce only on the local input; onChange/value are stable enough for this use.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input])

  // Follow external resets (e.g. "Clear filters") without fighting the user's typing.
  useEffect(() => {
    if (value === '') setInput('')
  }, [value])

  return (
    <div className='flex items-center justify-between flex-wrap gap-3' style={{ paddingBottom: 16 }}>
      <TextField
        size='small'
        placeholder={placeholder}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        style={{ width: '100%', maxWidth: 360 }}
        sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#fff', borderRadius: '8px' } }}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <FontAwesomeIcon
                icon={['far', 'search']}
                style={{ fontSize: 14, color: 'rgb(100, 116, 139)' }}
              />
            </InputAdornment>
          ),
          endAdornment: input ? (
            <InputAdornment position='end'>
              <IconButton aria-label='Clear search' size='small' onClick={() => setInput('')}>
                <FontAwesomeIcon icon={['fas', 'xmark']} style={{ fontSize: 13 }} />
              </IconButton>
            </InputAdornment>
          ) : null
        }}
      />
      {children ? <div className='flex items-center flex-wrap gap-2'>{children}</div> : null}
    </div>
  )
}

export default ListSearch
